const onEnter = (callback) => (event) => {
  switch (event.key) {
    case 'Enter': return callback(event)
  }
}

export {
  onEnter
}
